import React from "react";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Icon
} from "semantic-ui-react";
import GridRow from "semantic-ui-react/dist/commonjs/collections/Grid/GridRow";
import Chart from "../../components/Chart";
const ReactHighcharts = require('react-highcharts');

const BoxChart = ({
  header,
  data,
  showProductDetailsModal,
  inventory_details_data
}) => {
  // console.log("chart data : ",JSON.stringify(data))
  return (
    <Grid.Column verticalAlign="middle">
      <div style={{ ...styles.boxMain, height: 100 }}>
        <Grid.Row style={{ ...styles.heading, }}>
          <Header as="h5" style={styles.headingText}>
            {header}
          </Header>
        </Grid.Row>
        <ReactHighcharts config={data} ></ReactHighcharts>
        <span onClick={() => showProductDetailsModal(inventory_details_data)} style={styles.viewDetails}>
          View Details
        </span>


      </div>
    </Grid.Column>
  );
};

const styles = {
  boxMain: {
    minHeight: 170,
    marginBottom: 30,
    marginTop: 15,
    // paddingBottom: 20,
    paddingTop: 5,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    textAlign: "center",
    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)"
  },
  viewDetails: {
    fontSize: 15,
    color: "#109ed0",
    cursor: 'pointer', 
    fontFamily: 'Roboto',
    borderBottom: "1px solid #109ed0"
  },
  comparision: {
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    fontSize: 10,
    marginTop: 5
  },
  heading: {
    // flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 5
  },
  headingOne: {
    fontSize: 14,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginTop: 17
  },
  headingText: {
    marginTop:5,
    fontSize: 16,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginBottom: 1
  },
  icon: {
    height: 8,
    width: 10,
    justifyContent: "center",
    paddingTop: 0
  },
  textValue: {
    // fontSize: 32,
    // fontWeight: 400,
    // flex: 0,
    // flexDirection: "column",
    // justifyContent: "center",
    // alignItems: "center",
    // alignSelf: "center",
    // fontFamily: "Roboto",
    color: "#313131"
  }
};

export default BoxChart;



// WEBPACK FOOTER //
// ./src/components/BoxChart/index.js